'use client';

import React from 'react';
import { CanLogoIcon } from '@/../public/assets/icons';
import { Box, Text } from '@chakra-ui/react';
import 'react-phone-input-2/lib/style.css';
import { TClinicDetailsProps } from './types/template.types';
import AvailabilityForm from '../../forms/clinic/availability/AvailabilityForm';

const Availability = ({ next, details, previous }: TClinicDetailsProps) => {
   return (
      <>
         <Box minH="72px">
            <CanLogoIcon />
         </Box>
         <Text
            as="h2"
            color="white"
            fontSize={{ base: '4xl', sm: '5xl', md: '12xl' }}
            fontWeight="bold"
            textAlign="center"
         >
            Availability
         </Text>
         <Text color="white" textStyle="md" textAlign="center" mt="-10px" mb="2">
            Within what timescale will you contact the patient?
            <br />
         </Text>
         <AvailabilityForm next={next} details={details} previous={previous} />
      </>
   );
};

export default Availability;
